<template>
  <div class="wrapper">
    <Header headerBackground="" border title="圈子列表"></Header>
    <van-loading type="spinner" class="loading" v-if="loading"/>
    <div class="info--wrapper" v-else>
      <div class="info-bg">
        <img v-if="info.littleCoverImgUrl" :src="'//cdn-fs.touchev.com' + info.littleCoverImgUrl + '!w360'" alt="">
        <img v-else src="@/assets/images/circle-info-bg.png" alt="">
      </div>
      <div class="info">
        <div class="info_container">
          <div class="img--wrapper">
            <img v-if="info.littleCoverImgUrl" :src="'//cdn-fs.touchev.com' + info.littleCoverImgUrl + '!w360'" alt="">
            <img v-else src="@/assets/images/circle-info-bg.png" alt="">
          </div>
          <div class="info_wrapper">
            <div class="wrapper_content">
              <div class="info-title">{{ info.name }}</div>
              <div class="info-box">
                {{ info.followCnt }}
                <ul>
                  <li v-if="info.followCnt">{{ resetNum(info.followCnt) }}人关注</li>
                  <li v-else> 无人关注</li>
                  <li v-if="info.topicCnt">{{ resetNum(info.topicCnt) }}条内容</li>
                  <li v-else>无内容</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="info_author">
          <p v-if="info.summary" class="info-desc" v-html="resetContent"></p>
        </div>
      </div>
      <div class="tab--wrapper">
        <van-sticky :offset-top="46">
          <div class="info-tab">
            <ul>
              <li :class="{active:activeIndex===0}" @click="activeIndex=0">最新</li>
              <li :class="{active:activeIndex===1}" @click="activeIndex=1">精华</li>
            </ul>
          </div>
        </van-sticky>
        <div class="post-wrapper">
          <ul v-if="activeIndex===0">
            <van-list v-model:loading="list[0].loading" :finished="list[0].finished" :finished-text="list[0].items.length?list[0].text:''" v-model:error="list[0].error" error-text="请求失败，点击重新加载" @load="onLoad(0)">
              <listItem v-for="item in list[0].items" :key="item" :item="item" isCircle/>
              <div v-if="!list[0].items.length&&!list[0].loading">
                <van-empty class="custom-image" :image="emptyImage" :description="emptyText"/>
              </div>
            </van-list>
          </ul>
          <ul v-else-if="activeIndex===1">
            <van-list v-model:loading="list[1].loading" :finished="list[1].finished" :finished-text="list[1].items.length?list[0].text:''" v-model:error="list[1].error" error-text="请求失败，点击重新加载" @load="onLoad(1)">
              <listItem v-for="item in list[1].items" :key="item" :item="item" isCircle/>
              <div v-if="!list[1].items.length&&!list[1].loading">
                <van-empty class="custom-image" :image="emptyImage" :description="emptyText"/>
              </div>
            </van-list>
          </ul>
        </div>
      </div>
    </div>
    <div class="post-app-wrapper" @click="toApp">
      在APP中打开
    </div>
  </div>
</template>
<script>
import {Button, Dialog, Empty, List, Loading, PullRefresh, Toast, Sticky} from "vant";
import Header from "../../components/Header";
import {mapMutations, mapState} from "vuex";
import help from "../../assets/js/help";
import listItem from "../../components/listItem";
export default {
  name: "Circle",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Button.name]: Button,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog,
    [Sticky.name]: Sticky,
    Header,
    listItem
  },
  data() {
    return {
      info: {},
      list: [
        {
          items: [],
          refreshing: false,
          loading: false,
          error: false,
          finished: false,
          text: "没有更多内容",
          page: 1
        },
        {
          items: [],
          refreshing: false,
          loading: false,
          error: false,
          finished: false,
          text: "没有更多内容",
          page: 1
        }
      ],
      loading: false,
      finished: false,
      refreshing: false,
      id: "",
      emptyImage: require("@/assets/images/content-null.png"),
      emptyText: "暂时还没有内容～",
      defaultInfoBackground: require("@/assets/images/circle-info-bg.png"),
      activeIndex: 0
    };
  },
  computed: {
    ...mapState(["isTest", "totalIngral", "uid", "token", "time"]),
    url1() {
      if (this.isTest) {
        return "/shop/json/circle-user.json";
      } else {
        return "/api/h5/get-carpoolers-detail";
      }
    },
    url2() {
      if (this.isTest) {
        return "/shop/json/circle-list.json";
      } else {
        return "/api/h5/get-topic-at-carpoolers";
      }
    },
    resetContent() {
      const _content = this.info.summary;
      if (_content) {
        return help.replaceStringUrlToTag(_content);
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapMutations(["login", "setTotalIngral", "setTimeOut", "setAppInfo"]),
    resetNum(number) {
      return help.resetLargeNum(number);
    },
    param(index) {
      let foo = "?";
      if (this.id) {
        foo += "carpoolersId=" + this.id + "&";
      }
      if (index === 0) {
        foo += "isFeatured=" + 0 + "&";
      } else if (index === 1) {
        foo += "isFeatured=" + 1 + "&";
      }
      if (this.list[index].page) {
        foo += "page=" + this.list[index].page;
      } else {
        foo += "page=" + 1;
      }
      return foo;
    },
    infoBackground(bg) {
      if (bg) {
        return "background: url(//cdn-fs.touchev.com" + bg + "!w360) no-repeat center; background-size: cover;";
      }
    },
    getUserData() {
      this.axios.get(this.url1 + "?carpoolersId=" + this.id).then((res) => {
        if (res) {
          help.requestSuccess(res, false)
              .then((res) => {
                this.loading = false;
                if (this.info.id) {
                  this.info = {};
                }
                this.info = res.data;
                this.initTitle();
                if (this.isTimeOuted) {
                  this.setTimeOut(false);
                }
              }, (err) => {
                console.log(err);
                //Toast(err);
                help.resError(err, true, this.logout, this.setTimeOut);
              });
        }
      }, (err) => {
        help.requestError(err);
      });
    },
    getListData(index) {
      this.axios.get(this.url2 + this.param(index)).then((res) => {
        if (res) {
          help.requestSuccess(res, true)
              .then((res) => {
                this.loading = false;
                let list = this.list[index];
                res.data.forEach((e, i) => {
                  list.items.push(e);
                });
                list.loading = false;
                list.refreshing = false;
                list.page += 1;
                if (res.data.length < 20) {
                  list.finished = true;
                }
              }, (err) => {
                this.list[index].loading = false;
                this.list[index].error = true;
                help.resError(err, true, this.logout, this.setTimeOut);
              });
        }
      }, (err) => {
        help.requestError(err);
      });
    },
    onLoad(index) {
      const list = this.list[index];
      list.loading = true;
      setTimeout(() => {
        if (list.refreshing) {
          list.items = [];
          list.refreshing = false;
        }
        this.getListData(index);
        // for (let i = 0; i < 10; i++) {
        //   const text = list.items.length + 1;
        //   list.items.push(text < 10 ? "0" + text : String(text));
        // }
        // show error info in second demo
        // if (index === 1 && list.items.length === 10 && !list.error) {
        //   list.error = true;
        // } else {
        //   list.error = false;
        // }
        // if (list.items.length >= 40) {
        //   list.finished = true;
        // }
      }, 250);
    },
    onRefresh(index) {
      this.list[index].page = 1;
      this.list[index].finished = false;
      this.onLoad(index);
    },
    toApp() {
      const {pathname} = window.location;
      help.openApp(pathname);
    },
    initTitle() {
      const _name = this.info.name;
      if (_name) {
        document.title = _name + " - 第一电动网";
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getUserData();
    //this.getListData();
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.css";
.wrapper {
  padding-top: 45px;
  background: #fff;
}
.info--wrapper {
  position: relative;
}
.info-bg {
  width: 100%;
  height: 204px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(0, 0, 0, 0.5) 100%);
    z-index: 2;
  }
  & img {
    min-width: 100%;
    min-height: 100%;
    filter: blur(12px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
.info {
  padding: 62px 16px 0;
  min-height: 204px;
  background-size: cover;
  text-align: left;
  position: relative;
  & .info_container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & .img--wrapper {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 12px;
      position: relative;
      background: #242630;
      box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      & img {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    & .info_wrapper {
      position: relative;
      z-index: 2;
      color: #fff;
      & .info-title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC, serif;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 1.1;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 15px;
      }
      & .info-desc {
        font-size: 12px;
        color: inherit;
        margin-bottom: 23px;
        line-height: 1.3;
      }
      & .info-box {
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & ul {
          font-size: 12px;
          font-weight: inherit;
          color: inherit;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          & li {
            white-space: nowrap;
            &:not(:last-child) {
              padding-right: 10px;
              margin-right: 10px;
              border-right: 1px solid #fff
            }
          }
        }
      }
    }
  }
  & .info_author {
    min-height: 56px;
    background: #F8F8F8;
    padding: 16px;
    border-radius: 10px;
    margin: 20px auto 14px;
    & .box_author {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC, serif;
      font-weight: 400;
      color: #9B9B9B;
      :deep(.author--pic) {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      :deep(.author_type) {
        width: 8px;
        height: 8px;
      }
      :deep(.author-info) {
        max-width: 10em;
        margin-right: 8px;
      }
      & > .subject-type {
        flex-shrink: 0;
        height: 18px;
        & img {
          max-height: 100%;
        }
      }
      & .author-type {
        height: 16px;
        display: inline-flex;
        vertical-align: middle;
        align-items: center;
        background: #0E0E0E;
        border-radius: 6px;
        font-size: 10px;
        color: #fff;
        padding: 0 6px;
      }
    }
    & .info-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, serif;
      font-weight: 400;
      color: #0E0E0E;
      line-height: 1.5;
    }
  }
}
.tab--wrapper {
  margin-top: -15px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;
  position: relative;
  z-index: 2;
}
.info-tab {
  padding: 1px 12px;
  background: #fff;
  & ul {
    height: 18px;
    margin: 16px auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & li {
      font-size: 16px;
      color: #666A73;
      position: relative;
      &:not(:last-child) {
        margin-right: 20px;
      }
      &.active {
        font-size: 18px;
        color: #1A1B1F;
        font-weight: bold;
        &::after {
          content: "";
          width: 18px;
          height: 8px;
          background: url("../../assets/images/circle-tab-active.png") no-repeat center;
          background-size: contain;
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
.post-wrapper {
  padding: 16px 12px 0;
  text-align: left;
}
.post-app-wrapper {
  position: fixed;
  width: 37.3%;
  max-width: 140px;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  line-height: 50px;
  background: #FF6D20;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  border-radius: 1000px;
  z-index: 2;
}
</style>